module.exports = __webpack_public_path__ + "img/nsfs-lillestromMap.5e497cb1.jpg";